<!-- 充值弹窗 -->
<template>
	<div>
		<!-- 充值选择弹窗 -->
		<el-dialog
			width="650px"
			:modal-append-to-body="false"
			:show-close="true"
			:close-on-click-modal="false"
			:visible.sync="visible"
			:before-close="handleClose"
		>
			<el-tabs v-model="activeTab">
				<!-- 余额充值 -->
				<el-tab-pane :label="$t('common.Recharge.788265-0')" name="recharge">
					<div class="recharge-content">
						<!-- 充值金额输入 -->
						<div class="recharge-input-wrap">
							<span class="input-prefix">¥</span>
							<el-input
								v-model="inputAmount"
								:placeholder="$t('common.Recharge.788265-1')"
								@input="handleInputChange"
								@blur="handleInputBlur"
								maxlength="7"
							></el-input>
						</div>

						<!-- 充值金额选择 -->
						<div class="amount-grid">
							<div
								v-for="item in amountOptions"
								:key="item.figure"
								class="amount-item"
								:class="{ active: selectedAmount === item.figure }"
								@click="selectAmount(item)"
							>
								<div class="amount-value">¥ {{ item.figure }}</div>
								<div v-if="item.currGiftAmount > 0" class="amount-gift">
									{{ $t('common.Recharge.788265-2', [item.currGiftAmount]) }}
								</div>
							</div>
						</div>

						<!-- 底部操作区 -->
						<div class="recharge-footer">
							<div class="price-info">
								<span>
									{{ $t('common.Recharge.788265-3') }}
									<em v-if="isInputing">--</em>
									<em v-else>¥{{ payAmount.toFixed(2) }}</em>
								</span>
								<span class="price-divider">|</span>
								<span>
									{{ $t('common.Recharge.788265-4') }}
									<em v-if="isInputing">--</em>
									<em v-else>¥{{ receiveAmount.toFixed(2) }}</em>
								</span>
							</div>
							<div class="btn-group">
								<el-button @click="handleClose">{{ $t('common.action.cancel') }}</el-button>
								<el-button type="danger" @click="handleRecharge('')" :disabled="payAmount <= 0">
									{{ $t('common.Header.031511-6') }}
								</el-button>
							</div>
						</div>
					</div>
				</el-tab-pane>

				<!-- 充值说明 -->
				<el-tab-pane v-if="!!rechargeDescription" :label="$t('common.Recharge.788265-6')" name="instruction">
					<div class="instruction-content">
						{{ rechargeDescription }}
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 支付弹窗 -->
		<el-dialog
			width="400px"
			:modal-append-to-body="false"
			:show-close="true"
			:close-on-click-modal="false"
			:visible.sync="payDialogVisible"
			:before-close="handlePayClose"
			class="pay-dialog"
		>
			<div class="pay-dialog-content">
				<div class="pay-amount-info">
					<span>
						{{ $t('common.Recharge.788265-3') }}
						<em>¥{{ payAmount.toFixed(2) }}</em>
					</span>
					<span class="price-divider">，</span>
					<span>
						{{ $t('common.Recharge.788265-4') }}
						<em>¥{{ receiveAmount.toFixed(2) }}</em>
					</span>
				</div>
				<div class="pay-typechooose" v-if="isOpenWxPay && isOpenAliPay">
					<div
						class="typechooose-item"
						:class="{ active: payType === 'wxpay' }"
						@click="handleRecharge('wxpay')"
					>
						<img src="../../assets/images/pay/icon-wxpay.svg" />
						<span>{{ $t('common.Recharge.788265-7') }}</span>
					</div>
					<div
						class="typechooose-item"
						:class="{ active: payType === 'alipay' }"
						@click="handleRecharge('alipay')"
					>
						<img src="../../assets/images/pay/icon-alipay.svg" />
						<span>{{ $t('common.Recharge.788265-8') }}</span>
					</div>
				</div>
				<div class="pay-countdown">
					<span class="countdown-text">{{ $t('common.Recharge.788265-9') }}</span>
					<span class="countdown-time">{{ countdownStr }}</span>
				</div>
				<div class="qrcode-wrap">
					<div v-if="qrcodeLoaded" class="qrcode-img" id="qrCode"></div>
					<div v-else class="qrcode-placeholder">
						<i class="el-icon-loading"></i>
					</div>
				</div>
				<div class="pay-tip">
					<span v-if="payType == 'wxpay'">{{ $t('common.Recharge.788265-12', [$t('common.Recharge.788265-14')]) }}</span>
					<span v-else-if="payType == 'alipay'">{{ $t('common.Recharge.788265-12', [$t('common.Recharge.788265-15')]) }}</span>
					<span v-else-if="payType == 'unionpay'">{{ $t('common.Recharge.788265-12', [tlPayTipText]) }}</span>
					<span v-else-if="payType == 'huifudg'">{{ $t('common.Recharge.788265-12', [huifudgPayTipText]) }}</span>
					<span v-else>{{ $t('common.Recharge.788265-12', [[$t('common.Recharge.788265-14'), $t('common.Recharge.788265-15'), $t('common.Recharge.788265-16')].join('/')]) }}</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getCustomerInfo } from "../../utils/api-utils/api-customer.js";
	import { getParam } from "../../utils/api-utils/api-params.js";
	import {
		createRecharge,
		getRechargeActivityList,
		calcRechargeGiftAmount,
		getRechargeStatus,
	} from "../../utils/api-utils/api-recharge";
	import commonUtils from "../../utils/common-utlis.js";
	import { getPayUrlForWxAliUnion } from "../../utils/api-utils/api-pay.js";
	import QRCode from "qrcodejs2";
	import tradeUtils from "../../utils/api-utils/api-trade.js";
	export default {
		name: "RechargeDialog",
		props: {
			isShow: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				activeTab: "recharge",
				inputAmount: "",
				selectedAmount: null,
				giftAmount: 0,
				customerInfo: {},
				qrcodeLoaded: false,
				isInputing: false,
				isOpenWxPay: false,
				isOpenAliPay: false,
				tlPayTipText: "",
				tlPayTypeTipTextMap: {
					wxpay: this.$t('common.Recharge.788265-14'),
					alipay: this.$t('common.Recharge.788265-15'),
					yinlian: this.$t('common.Recharge.788265-16'),
				}, // 通联支持支付方式映射
				paymentPlatformMap: {
					wxpay: "jsapi",
					alipay: "alipay",
					unionpay: "tonglian",
					ylswpay: "ylsw",
					shouqianba: "shouqianba",
					huifudg: "huifudg",
				}, // 支付平台映射
				huiFuPayTypeMap: {
					aliOfHuiFuDouGong: {
						payTypeName: this.$t('common.Recharge.788265-15'),
						payType: "",
						isQrCode: true,
					},
					unionOfHuiFuDouGong: {
						payTypeName: this.$t('common.Recharge.788265-17'),
						payType: "",
						isQrCode: true,
					},
					huifudg: {
						payType: "",
						isQrCode: true,
					},
					bigAmountForHuiFuDouGong: {
						payType: "yinlian",
						isQrCode: false,
						paymentPlatform: "huifudglarge",
					},
				}, // 汇付支付参数映射
				// 支付弹窗
				payDialogVisible: false,
				qrcodeUrl: "",
				payType: "wxpay",
				countdownStr: "03:37",
				countdownTimer: null,
				countdownSeconds: 217,
				amountOptions: [],
				rechargeActivityList: [],
				rechargeDescription: "",
			};
		},
		computed: {
			visible: {
				get() {
					return this.isShow;
				},
				set(val) {
					if (!val) this.handleClose();
				},
			},
			payAmount() {
				if (this.inputAmount && !isNaN(Number(this.inputAmount))) {
					return Number(this.inputAmount);
				}
				return this.selectedAmount || 0;
			},
			receiveAmount() {
				return this.payAmount + (this.giftAmount || 0);
			},
		},
		created: async function () {
			// 获取用户信息
			await this.getCustomerInfo();

			// 加载用户配置参数
			await this.loadParams();

			// 获取充值活动
			await this.getRechargeActivityInfo();
		},
		methods: {
			/*
			 * 获取客户信息
			 */
			async getCustomerInfo() {
				this.customerInfo = await getCustomerInfo();
			},

			/*
			 * 加载用户配置参数
			 */
			async loadParams() {
				let paramsList = await getParam(
					"isOpenRechargeGift,rechargeTips,pc_isOpenTonglianPay,pc_isOpenYlswPay,pc_isOpenWxPay,pc_isOpenAliPay,tonglianSupplyPayTypeOfPc,rechargeOptions,rechargeDescription,pc_isOpenHuiFuPay,pc_isOpenShouqianbaPay,isOpenUnionOrAliForHuiFuDouGong,payTypeOfHuiFuDouGong"
				);

				// 是否开启充值送
				this.isOpenRechargeGift = paramsList.isOpenRechargeGift == "1";

				// 充值提示说明
				this.rechargeTipList = (paramsList.rechargeTips || "").split(",");

				// 支持的支付方式
				this.isOpenTonglianPay = paramsList.pc_isOpenTonglianPay == "1";
				this.isOpenWxPay = paramsList.pc_isOpenWxPay == "1";
				this.isOpenAliPay = paramsList.pc_isOpenAliPay == "1";
				this.tonglianSupplyPayTypeOfPc = paramsList.tonglianSupplyPayTypeOfPc || "wxpay,alipay,yinlian";
				this.payTypeOfHuiFuDouGong = paramsList.payTypeOfHuiFuDouGong || "";
				this.isOpenUnionOrAliForHuiFuDouGong = paramsList.isOpenUnionOrAliForHuiFuDouGong == "1";

				this.tlPayTipText = this.tonglianSupplyPayTypeOfPc
					.split(",")
					.map(item => this.tlPayTypeTipTextMap[item])
					.join("/");

				this.huifudgPayTipText = this.getHuifudgTipText();

				// 默认支付方式
				if (paramsList.pc_isOpenShouqianbaPay == "1") {
					this.defaultPayType = "shouqianba";
				} else if (paramsList.pc_isOpenHuiFuPay == "1") {
					this.defaultPayType = "huifudg";
				} else if (paramsList.pc_isOpenYlswPay == "1") {
					this.defaultPayType = "ylswpay";
				} else if (this.isOpenTonglianPay) {
					this.defaultPayType = "unionpay";
				} else {
					this.defaultPayType = `${this.isOpenWxPay ? "wxpay" : ""}${!this.isOpenWxPay && this.isOpenAliPay ? "alipay" : ""}`;
				}

				this.amountOptions = (paramsList.rechargeOptions || "20,50,100,200,500,1000")
					.split(",")
					.map(item => ({ figure: item }));
				this.rechargeDescription = paramsList.rechargeDescription || "";
			},

			/*
			 * 获取充值活动
			 */
			async getRechargeActivityInfo() {
				let rechargeActivityList = await getRechargeActivityList(this.customerInfo.vipLevel || "");

				// 不存在充值活动 直接返回
				if (!this.isOpenRechargeGift || !(rechargeActivityList && rechargeActivityList.length > 0)) {
					return;
				}

				// 充值送策略列表
				this.rechargeActivityList = rechargeActivityList;

				// 充值送策略排序
				this.sortRechargeActivityList();

				// 计算每项的赠送金额
				this.setGiftAmount();

				this.rechargeActivityList = this.rechargeActivityList.filter(item => item.currGiftAmount > 0);

				// 合并amountOptions和rechargeActivityList
				this.mergeAmountOptionsAndRechargeActivityList();
			},

			/*
			 * 充值送策略排序
			 */
			sortRechargeActivityList() {
				let rechargeActivityList = this.rechargeActivityList;
				// 根据 创建时间 降序排序
				rechargeActivityList = rechargeActivityList.sort((a, b) => {
					if (a.figure == b.figure) {
						return a.prechargeEventId - b.prechargeEventId;
					}
					return a.figure - b.figure;
				});

				// 相同figure数据只保留最大的
				this.rechargeActivityList = Object.values(
					rechargeActivityList.reduce((acc, cur) => {
						if (!acc[cur.figure]) {
							acc[cur.figure] = cur;
						}
						return acc;
					}, {})
				).sort((a, b) => a.figure - b.figure);
			},

			/*
			 * 计算每项的赠送金额
			 */
			setGiftAmount() {
				// 活动列表
				let rechargeActivityList = this.rechargeActivityList;

				// 总赠送金额
				rechargeActivityList.forEach(item => {
					// 可叠加的赠送金额
					item.currGiftAmount = this.calcGiftAmount(item.figure, item);
				});
			},

			/**
			 * 计算赠送金额
			 * @param specifiedAmount 指定金额
			 * @param settingInfo 设置信息
			 */
			calcGiftAmount: function (specifiedAmount, settingInfo) {
				// 过滤出类型为 赠送余额的数据
				let currSettingdetailList = settingInfo.giftDetailArr.filter(giftItem => giftItem.giftType == 0);

				// 可叠加的赠送金额
				let tempAmount = currSettingdetailList.reduce((accumulator, currentSetting) => {
					// 是否可叠加
					let isSuperposition = currentSetting.isSuperposition == 1;
					// 是否是 赠送指定比例
					let isPersent = currentSetting.gift == "赠送指定比例";
					// 实际充值金额 和 设置的充值金额下限 之间的比例
					let persentOfRechargeAndFigure = isSuperposition
						? Math.floor(specifiedAmount / settingInfo.figure)
						: 1;

					// 赠送金额
					let currentSettingAmount = isPersent
						? (specifiedAmount * currentSetting.num) / 100
						: currentSetting.num * persentOfRechargeAndFigure;

					// 赠送金额 和 设置的限制金额取小
					currentSettingAmount = Math.min(
						currentSettingAmount,
						!currentSetting.rest && currentSetting.rest !== 0 ? 999999999999 : currentSetting.rest
					);

					// 根据设置计算出的赠送金额
					return commonUtils.mathFloorWithDecimal(currentSettingAmount + accumulator);
				}, 0);

				return tempAmount;
			},

			/*
			 * 合并amountOptions和rechargeActivityList
			 */
			mergeAmountOptionsAndRechargeActivityList() {
				let rechargeActivityList = this.rechargeActivityList;
				this.amountOptions = commonUtils
					.mergeAndSumV2(
						[
							...this.amountOptions,
							...this.rechargeActivityList.map(item => {
								return { figure: Number(item.figure), currGiftAmount: item.currGiftAmount };
							}),
						],
						["figure"],
						["currGiftAmount"]
					)
					.filter(item => item.figure > 0)
					.sort((a, b) => a.figure - b.figure);
				this.amountOptions.forEach(option => {
					// 1. 筛选出所有 figure 小于当前档位 figure 的活动
					// 比如当前档位是 60，这里会筛选出 figure 为 50 和 45 的活动
					const validActivities = rechargeActivityList.filter(activity => activity.figure <= option.figure);

					if (validActivities.length > 0) {
						// 2. 在这些活动中，找到 figure 最大的那个（最接近当前档位的）
						const bestMatch = validActivities.reduce((prev, current) => {
							return prev.figure > current.figure ? prev : current;
						});

						// 3. 将找到的活动赠品金额赋值给当前档位
						option.currGiftAmount = option.currGiftAmount || this.calcGiftAmount(option.figure, bestMatch);
						option.prechargeEventInfo = bestMatch;
					}
					// 如果没有小于它的活动，则不赋值（保持 undefined 或原值）
				});
			},

			/**
			 * 校验赠送策略是否变化
			 */
			checkGiftAmount: async function () {
				if (!this.giftAmount || this.giftAmount == 0) {
					return true;
				}

				let calcResultOfCrm = await calcRechargeGiftAmount(this.customerInfo, this.inputAmount, [
					this.prechargeEventInfo.prechargeEventId,
				]);
				if (calcResultOfCrm != this.giftAmount) {
					this.$message.error(this.$t('common.Recharge.788265-18'));
					return false;
				}

				return true;
			},

			/**
			 * 创建充值单
			 */
			createdRecharge: async function () {
				let rechargeActivityJson = {
					prechargeEventId: this.prechargeEventInfo && this.prechargeEventInfo.prechargeEventId,
					customerId: this.customerInfo.customerId,
					vipGradeId: this.customerInfo.vipLevel || "",
					giftDetailDtoArr: this.prechargeEventInfo && this.prechargeEventInfo.giftDetailArr,
				};
				// 创建充值单
				let res = await createRecharge(this.inputAmount, this.giftAmount, rechargeActivityJson);
				if (!res.rechargeNo) {
					this.$message.error(this.$t('common.Recharge.788265-19'));
					return false;
				}

				return res.rechargeNo;
			},

			/**
			 * 获取支付二维码
			 */
			getPayUrlQRCode: async function (rechargeTradeNo, payType) {
				this.qrcodeLoaded = false;
				this.payType = payType || this.defaultPayType;

				// 清空二维码容器内容
				this.clearQRCode();

				// 启动倒计时
				this.startCountdown();

				// 请求参数
				let requestJson = {
					tradeNo: rechargeTradeNo,
					totalAmount: this.inputAmount,
					outTradeNo: rechargeTradeNo,
					payScene: 1,
					payType: this.payType == "unionpay" ? "" : this.payType,
					payPurpose: 2,
					paymentPlatform: this.paymentPlatformMap[this.payType],
				};

				// 调用接口获取付款码链接
				let payUrl = await getPayUrlForWxAliUnion(requestJson);
				// 检测获取结果
				if (!payUrl) {
					return;
				}
				this.qrcodeLoaded = true;

				// 生成支付二维码
				setTimeout(() => {
					this.createQRCode(payUrl);
				}, 100);
			},

			clearQRCode() {
				if (!document.getElementById("qrCode")) {
					return;
				}
				// 清空二维码容器内容
				document.getElementById("qrCode").innerHTML = "";
			},

			/**
			 * 创建二维码
			 */
			createQRCode(content) {
				// 没有内容则直接返回
				if (!content) {
					return false;
				}

				try {
					// 清空二维码容器内容
					this.clearQRCode();
				} catch (e) {}
				// 生成二维码
				new QRCode("qrCode", {
					text: content,
					width: 200,
					height: 200,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
			},

			handleClose() {
				this.$emit("update:isShow", false);
				this.resetData();
			},
			selectAmount(item) {
				this.selectedAmount = item.figure;
				this.inputAmount = item.figure;
				this.giftAmount = item.currGiftAmount;
				this.prechargeEventInfo = item.prechargeEventInfo || {};
			},
			handleInputBlur() {
				// 策略匹配 figure最大且创建时间最近的
				let settingInfo = this.rechargeActivityList
					.filter(item => item.figure <= this.inputAmount)
					.toReversed()[0];

				// 赠送金额
				this.giftAmount =
					!!this.inputAmount && settingInfo ? this.calcGiftAmount(this.inputAmount, settingInfo) : 0;

				this.isInputing = false;
				this.prechargeEventInfo = settingInfo || {};
			},
			handleInputChange(val) {
				this.isInputing = true;
				if (val) {
					this.selectedAmount = null;
					// 限制小数位最多两位
					const dotIndex = val.indexOf(".");
					if (dotIndex !== -1 && val.length > dotIndex + 3) {
						this.inputAmount = val.slice(0, dotIndex + 3);
					}
				}
			},
			resetData() {
				this.inputAmount = "";
				this.selectedAmount = null;
				this.activeTab = "recharge";
			},
			async handleRecharge(payType) {
				let rechargeAmount = this.payAmount;
				if (isNaN(rechargeAmount)) return this.$message.error(this.$t('common.Recharge.788265-20'));

				if (rechargeAmount <= 0) return this.$message.error(this.$t('common.Recharge.788265-21'));

				//限制金额大小
				if (rechargeAmount >= Math.pow(10, 7)) return this.$message.error(this.$t('common.Recharge.788265-22'));

				// 校验充值策略
				if (!(await this.checkGiftAmount())) {
					return;
				}

				// 显示加载中弹窗
				commonUtils.showLoading(this);

				// 创建充值单
				this.rechargeTradeNo = await this.createdRecharge();

				if (!this.rechargeTradeNo) {
					commonUtils.closeLoading(this);

					return;
				}

				// 获取支付二维码
				this.getPayUrlQRCode(this.rechargeTradeNo, payType);

				// 打开支付弹窗
				this.payDialogVisible = true;

				// 支付结果轮询
				this.checkRechargeStatus(this.rechargeTradeNo);

				// 关闭加载中弹窗
				commonUtils.closeLoading();
			},

			/**
			 * 支付结果轮询
			 */
			async checkRechargeStatus(rechargeTradeNo) {
				if (!this.payDialogVisible) {
					return;
				}

				// 获取当前订单状态
				let tradeStatus = await getRechargeStatus(rechargeTradeNo);

				if (!this.payDialogVisible || rechargeTradeNo != this.rechargeTradeNo) {
					return;
				}

				if (tradeStatus == 1) {
					this.$message.success(this.$t('common.Recharge.788265-23', [(this.receiveAmount || 0).toFixed(2)]));
					this.$eventBus.$emit("updateBalanceByRecharge");
					this.handlePayClose();
					this.handleClose();
					return;
				} else if (tradeStatus == 0) {
					// 递归调用，1.5秒检测一次
					setTimeout(() => {
						this.checkRechargeStatus(rechargeTradeNo);
					}, 1500);
				} else {
					this.$message.success(this.$t('common.Recharge.788265-24'));
				}
			},

			/**
			 * 关闭支付弹窗
			 */
			handlePayClose() {
				this.payDialogVisible = false;
				this.stopCountdown();
			},

			/**
			 * 选择支付方式
			 */
			selectPayType(type) {
				this.payType = type;
			},

			/**
			 * 开始倒计时
			 */
			startCountdown() {
				this.countdownSeconds = 300;
				this.formatCountdown();

				if (this.countdownTimer) clearInterval(this.countdownTimer);
				this.countdownTimer = setInterval(() => {
					this.countdownSeconds--;
					if (this.countdownSeconds <= 0) {
						this.handlePayClose();
						return;
					}
					this.formatCountdown();
				}, 1000);
			},

			/**
			 * 停止倒计时
			 */
			stopCountdown() {
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
			},

			/**
			 * 格式化倒计时 mm:ss
			 */
			formatCountdown() {
				let m = Math.floor(this.countdownSeconds / 60);
				let s = this.countdownSeconds % 60;
				this.countdownStr = String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
			},

			/**
			 * 获取提示文本
			 */
			getHuifudgTipText() {
				let payTypeList = [this.$t('common.Recharge.788265-14')];
				if (this.isOpenUnionOrAliForHuiFuDouGong && !!this.payTypeOfHuiFuDouGong) {
					let tempArr = this.payTypeOfHuiFuDouGong.split(",").map(item => {
						return this.huiFuPayTypeMap[item].payTypeName;
					});

					payTypeList = payTypeList.concat(tempArr);
				}

				return payTypeList.join("/");
			},
		},
	};
</script>

<style scoped="scoped">
	.recharge-content {
		padding: 20px 30px 0;
	}

	.recharge-input-wrap {
		display: flex;
		align-items: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 0 15px;
		margin-bottom: 20px;
	}

	.recharge-input-wrap .input-prefix {
		font-size: 18px;
		color: #606266;
		margin-right: 8px;
	}

	.recharge-input-wrap >>> .el-input__inner {
		border: none;
		padding: 0;
		font-size: 16px;
	}

	.amount-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
		margin-bottom: 25px;
		height: 220px;
		overflow-y: auto;
		padding: 12px 14px 12px 12px;
		background-color: #f5f5f5;
		border-radius: 6px;
	}

	.instruction-content::-webkit-scrollbar,
	.amount-grid::-webkit-scrollbar {
		width: 1px;
	}

	.amount-grid::-webkit-scrollbar-thumb {
		background-color: #c0c4cc;
		border-radius: 1px;
	}

	.amount-item {
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		height: 72px;
		text-align: center;
		cursor: pointer;
		transition: all 0.2s;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.amount-item:hover {
		border-color: #f56c6c;
		color: #f56c6c;
	}

	.amount-item.active {
		border-color: #f56c6c;
		background: #fef0f0;
		position: relative;
	}

	.amount-value {
		font-size: 20px;
		font-weight: bold;
		color: #303133;
		margin-bottom: 4px;
	}

	.amount-gift {
		font-size: 12px;
		color: #909399;
	}

	.amount-item.active .amount-value,
	.amount-item.active .amount-gift {
		color: #f56c6c;
	}

	.recharge-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 18px;
		border-top: 1px solid #ebeef5;
	}

	.price-info {
		font-size: 14px;
		color: #606266;
		margin-right: 8px;
	}

	.price-info span {
		margin-right: 2px;
	}

	.price-divider {
		color: #dcdfe6;
		margin-left: 2px;
	}

	.price-info em {
		font-style: normal;
		color: #f56c6c;
		font-size: 18px;
		font-weight: bold;
		margin-left: 4px;
	}

	.btn-group {
		display: flex;
	}

	.btn-group >>> .el-button {
		min-width: 84px;
	}

	.btn-group >>> .el-button + .el-button {
		margin-left: 12px;
	}

	.instruction-content {
		padding: 20px 30px;
		line-height: 1.8;
		font-size: 13px;
		color: #606266;
		height: 370px;
		overflow: auto;
		white-space: pre-line;
	}

	.instruction-content p {
		margin-bottom: 12px;
		text-align: justify;
	}

	/* 支付弹窗 */
	.pay-dialog-content {
		padding: 30px 40px;
		text-align: center;
	}

	.pay-dialog .pay-title {
		font-size: 15px;
		color: #606266;
		margin-bottom: 16px;
	}

	.pay-amount-info {
		font-size: 14px;
		color: #909399;
		margin-bottom: 20px;
	}

	.pay-amount-info em {
		font-style: normal;
		color: #f56c6c;
		font-weight: bold;
		margin-left: 2px;
	}

	.pay-countdown {
		font-size: 13px;
		color: #f56c6c;
		margin-bottom: 16px;
	}

	.countdown-time {
		font-weight: bold;
		margin-left: 8px;
		font-family: "Courier New", monospace;
	}

	.qrcode-wrap {
		width: 200px;
		height: 200px;
		margin: 0 auto 16px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
	}

	.qrcode-img {
		width: 200px;
		height: 200px;
	}

	.qrcode-placeholder {
		font-size: 32px;
		color: #c0c4cc;
	}

	.pay-tip {
		font-size: 12px;
		color: #909399;
	}

	.pay-typechooose {
		display: flex;
		width: 300px;
		margin: 10px auto;
		justify-content: space-evenly;
		align-items: center;
	}

	.typechooose-item {
		display: flex;
		align-items: center;
		padding: 8px 16px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.2s;
		background: #fff;
	}

	.typechooose-item:hover {
		border-color: #409eff;
	}

	.typechooose-item.active {
		border-color: #409eff;
		background: #ecf5ff;
	}

	.pay-typechooose img {
		width: 32px;
		height: 32px;
		margin-right: 4px;
	}
</style>
